<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb -->
    <div class="mb-2">
      <div class="breadcrumb-container">
        <router-link to="/tramite-consulta">Trámites</router-link> >
        Trámite {{ p_idTramite }}: Atenciones con observaciones
        <span v-if="itemSeleccionado">
          > Número de atención: {{ itemSeleccionado.numero }}
        </span>
      </div>
    </div>
    <hr class="mt-1 mb-2" />

<hr class="mt-1 mb-2" />
<!-- Instrucciones -->
<div class="alert alert-info py-2 px-3 mb-3" role="alert">
  <strong>Instrucciones:</strong>
  Seleccione el <strong>Periodo</strong> y el <strong>Tipo de Observación</strong> para cargar los registros en la lista izquierda.
  Use el filtro <strong>Estado</strong> para ver todos, solo los <strong>respondidos</strong> o solo los <strong>pendientes sin respuesta</strong>.
  Haga clic en un registro de la lista para visualizar y completar la respuesta correspondiente.
</div>

    <!-- Panel superior: filtros -->
    <div class="card border-0 shadow-sm mb-3" style="background-color: #f8f9fa;">
      <div class="card-body py-2">
        <div class="row g-2 align-items-end">
          <div class="col-3">
            <label class="form-label fw-bold mb-1 small">Periodo</label>
            <select class="form-select form-select-sm" v-model="cargaSeleccionada"
              @change="getDataLista()">
              <option disabled value="">Seleccione ...</option>
              <option v-for="carga in cargas" :key="carga.idCarga" :value="carga.idCarga">
                {{ getFormattedDate(carga.fechaDesde) }}
                {{ carga.tipoCarga === 'M' ? 'Mensual' : carga.tipoCarga === 'S' ? 'Semanal' : carga.tipoCarga === 'A' ? 'Autorización' : 'Desconocido' }}
              </option>
            </select>
          </div>
          <div class="col-3">
            <label class="form-label fw-bold mb-1 small">Tipo de observación</label>
            <select class="form-select form-select-sm" v-model="tipoObsSeleccionado"
              @change="getDataLista()">
              <option disabled value="">Seleccione ...</option>
              <option value="M">Auditoría Médica</option>
              <option value="D">Gestión Documental</option>
            </select>
          </div>
<div class="col-3">
  <label class="form-label fw-bold mb-1 small">Estado</label>
  <select class="form-select form-select-sm" v-model="filtroEstado" @change="getDataLista()">
    <option value="todos">Todos</option>
    <option value="respondidos">Respondidos</option>
    <option value="pendientes">Sin respuesta</option>
  </select>
</div>
<div class="col-3">
  <label class="form-label fw-bold mb-1 small">Justificado</label>
  <select class="form-select form-select-sm" v-model="filtroRevisado" @change="getDataLista()">
    <option value="todos">Todos</option>
    <option value="1">Justificado</option>
    <option value="0">No justificado</option>
  </select>
</div>
        </div>
      </div>
    </div>
	
<!-- Botones de exportación -->
<div class="d-flex justify-content-end gap-2 mb-3">
  <button
    class="btn btn-outline-success btn-sm d-flex align-items-center gap-1"
    @click="exportarVistaActual"
    :disabled="planillasFiltradas.length === 0"
    title="Exporta los registros que se ven en la lista, según los filtros actuales"
  >
    <span class="material-symbols-outlined" style="font-size:16px">download</span>
    Exportar vista actual
  </button>

  <button
    class="btn btn-success btn-sm d-flex align-items-center gap-1"
    @click="exportarTodasObservaciones"
    :disabled="exportandoTodas"
  >
    <span class="material-symbols-outlined" style="font-size:16px">download</span>
    {{ exportandoTodas ? 'Generando...' : 'Exportar todas las observaciones del trámite' }}
  </button>
</div>	

    <!-- Paneles izquierdo y derecho -->
    <div class="d-flex gap-3" style="align-items: flex-start;">

      <!-- Panel izquierdo: lista (20%) -->
      <div style="width: 20%; min-width: 200px; flex-shrink: 0;">
        <div class="card border-0 shadow-sm" style="background-color: #f8f9fa;">
          <div class="card-header bg-secondary text-white py-1 d-flex justify-content-between align-items-center">
            <small class="fw-bold">Registros</small>
            <span class="badge bg-light text-dark">{{ planillasFiltradas.length }}</span>
          </div>
          <div class="card-body p-1" style="max-height: calc(100vh - 260px); overflow-y: auto;">
            <!-- Filtro búsqueda -->
            <div class="p-1">
              <input
                v-model="filtroLista"
                class="form-control form-control-sm"
                placeholder="🔍 Buscar..."
                @input="itemSeleccionado = null"
              />
            </div>

            <!-- Sin resultados -->
            <div v-if="planillasFiltradas.length === 0 && cargaSeleccionada && tipoObsSeleccionado"
              class="alert alert-warning py-1 px-2 small mb-0 mt-1">
              Sin registros
            </div>

            <!-- Lista de items -->
            <div v-for="item in planillasFiltradas" :key="item.idVwObservaciones"
              @click="seleccionarItem(item)"
              class="p-2 border-bottom"
              style="cursor: pointer; font-size: 0.8rem;"
              :style="itemSeleccionado && itemSeleccionado.idVwObservaciones === item.idVwObservaciones
                ? 'background-color: #cfe2ff; border-left: 3px solid #0d6efd;'
                : 'background-color: white;'"
              @mouseover="$event.currentTarget.style.backgroundColor = itemSeleccionado && itemSeleccionado.idVwObservaciones === item.idVwObservaciones ? '#cfe2ff' : '#f0f4ff'"
              @mouseout="$event.currentTarget.style.backgroundColor = itemSeleccionado && itemSeleccionado.idVwObservaciones === item.idVwObservaciones ? '#cfe2ff' : 'white'"
            >
              <div class="d-flex justify-content-between align-items-center">
                <span class="fw-bold">{{ item.numero }}</span>
                <span v-if="!item.idRespuesta" class="badge bg-danger" style="font-size: 0.65rem;">
                  Pendiente
                </span>
                <span v-else class="badge bg-success" style="font-size: 0.65rem;">
                  Respondido
                </span>
              </div>
              <div class="text-muted"
                style="font-size: 0.72rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                {{ item.observacionEstandar }}
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Panel derecho: formulario (80%) -->
      <div style="flex: 1; min-width: 0;">

        <!-- Sin selección -->
        <div v-if="!itemSeleccionado"
          class="card border-0 shadow-sm d-flex align-items-center justify-content-center"
          style="background-color: #f8f9fa; min-height: 300px;">
          <div class="text-center text-muted p-4">
            <span class="material-symbols-outlined" style="font-size: 48px; color: #ced4da;">
              touch_app
            </span>
            <p class="mt-2">Seleccione un registro de la lista para editar</p>
          </div>
        </div>

        <!-- Formulario -->
        <div v-else>

          <!-- Info atención -->
          <div class="card mb-3 border-primary">
            <div class="card-header bg-primary text-white py-2">
              <span class="material-symbols-outlined" style="vertical-align: middle; font-size: 18px;">
                person
              </span>
              <strong class="ms-1 small">Datos de la atención</strong>
            </div>
            <div class="card-body py-2">
              <div class="row g-2 small">
                <div class="col-auto">
                  <span class="fw-bold text-muted">Número:</span>
                  <span class="ms-1 badge bg-secondary">{{ itemSeleccionado.numero }}</span>
                </div>
                <div class="col-auto">
                  <span class="fw-bold text-muted">Cédula:</span>
                  <span class="ms-1">{{ itemSeleccionado.cedula }}</span>
                </div>
                <div class="col-auto">
                  <span class="fw-bold text-muted">Nombre:</span>
                  <span class="ms-1">{{ itemSeleccionado.nombre }}</span>
                </div>
                <div class="col-auto">
                  <span class="fw-bold text-muted">Fecha desde:</span>
                  <span class="ms-1">{{ getFormattedDate(itemSeleccionado.fechaDesde) }}</span>
                </div>
                <div class="col-auto">
                  <span class="fw-bold text-muted">Fecha hasta:</span>
                  <span class="ms-1">{{ getFormattedDate(itemSeleccionado.fechaHasta) }}</span>
                </div>
                <!-- Horas solo para DETALLE -->
                <template v-if="itemSeleccionado.nivel !== 'PLANILLA'">
                  <div class="col-auto">
                    <span class="fw-bold text-muted">Hora desde:</span>
                    <span class="ms-1">{{ itemSeleccionado.horaDesde }}</span>
                  </div>
                  <div class="col-auto">
                    <span class="fw-bold text-muted">Hora hasta:</span>
                    <span class="ms-1">{{ itemSeleccionado.horaHasta }}</span>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <!-- Formulario observación -->
          <div class="card shadow-sm border border-primary" style="background-color: #f1f3f5;">
            <div class="card-body">
              <form>

                <!-- Campos adicionales solo para DETALLE -->
                <template v-if="itemSeleccionado.nivel !== 'PLANILLA'">
<!--				
                  <div class="mb-3">
                    <label class="form-label fw-bold text-muted small">
                      Código del prestador de salud
                    </label>
                    <p class="form-control-plaintext border-bottom pb-1">
                      {{ datoPlaObs.planillaDetCodigo }} - {{ datoPlaObs.planillaDetDescripcion }}
                    </p>
                  </div>
-->				  
                  <div class="mb-3">
                    <label class="form-label fw-bold text-muted small">
                      Descripción
                    </label>
<!--					
                    <p class="form-control-plaintext border-bottom pb-1">
                      {{ datoPlaObs.elementoCodigo }} - {{ datoPlaObs.elementoNombre }}
                    </p>
-->					
                    <p class="form-control-plaintext border-bottom pb-1">
                      {{ datoPlaObs.elementoNombre }}
                    </p>
                  </div>
                </template>

                <!-- Observación estándar -->
                <div class="mb-3">
                  <label class="form-label fw-bold text-muted small">Observación estándar</label>
                  <p class="form-control-plaintext border-bottom pb-1">
                    {{ datoPlaObs.observacionDescripcion }}
                  </p>
                </div>

                <!-- Descripción complementaria -->
                <div class="mb-3">
                  <label class="form-label fw-bold text-muted small">Observación complementaria</label>
                  <p class="form-control-plaintext border-bottom pb-1"
                    style="text-transform: uppercase; white-space: pre-wrap;">
                    {{ datoPlaObs.descripcion }}
                  </p>
                </div>

                <!-- Respuesta estándar -->
                <div class="mb-3">
                  <label for="idRespuesta" class="form-label fw-bold">Respuesta estándar</label>
                  <select class="form-select" id="idRespuesta" v-model="datoPlaObs.idRespuesta">
                    <option disabled value="">Seleccione una respuesta...</option>
                    <option v-for="respuesta in respuestas"
                      :value="respuesta.idRespuesta" :key="respuesta.idRespuesta">
                      {{ respuesta.descripcion }}
                    </option>
                  </select>
                </div>

                <!-- Respuesta complementaria + micrófono -->
                <div class="mb-3">
                  <label for="respuesta" class="form-label fw-bold">Respuesta complementaria</label>
                  <div class="d-flex gap-2 align-items-start">
                    <textarea class="form-control" id="respuesta"
                      v-model="datoPlaObs.respuesta"
                      style="text-transform: uppercase;" rows="4">
                    </textarea>
                    <div class="d-flex flex-column align-items-center justify-content-center pt-1">
                      <button
                        v-if="isDictatingCampo !== 'respuesta'"
                        @click="startDictation('respuesta')"
                        type="button"
                        class="btn btn-outline-danger"
                        title="Iniciar dictado"
                        style="width: 52px; height: 52px;"
                      >
                        <span class="material-symbols-outlined" style="font-size: 28px;">mic_off</span>
                      </button>
                      <button v-else @click="stopDictation" type="button"
                        class="btn btn-outline-success" title="Finalizar dictado"
                        style="width: 52px; height: 52px;">
                        <span class="material-symbols-outlined" style="font-size: 28px;">mic</span>
                      </button>
                      <small class="text-muted mt-1" style="font-size: 0.7rem;">
                        {{ isDictatingCampo === 'respuesta' ? 'Grabando' : 'Dictado' }}
                      </small>
                    </div>
                  </div>
                </div>

                <!-- Botón guardar -->
                <div class="d-flex justify-content-end border-top pt-3 mt-2">
                  <button type="button" class="btn btn-primary"
                    @click.prevent="guardarRespuesta" title="Guardar respuesta">
                    <span class="material-symbols-outlined"
                      style="font-size: 20px; vertical-align: middle;">
                      save
                    </span>
                    Guardar
                  </button>
                </div>

              </form>
            </div>
          </div>

        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import dateFormat from "@/modules/dateFormat.js";
import SpeechDictation from "@/modules/microfono.js";
import swal from "sweetalert";
import * as XLSX from "xlsx";

export default {
  components: { Layout, Footer },
  data() {
    return {
      // Lista
      planillas: [],
      itemSeleccionado: null,
      tipoObsSeleccionado: "",
      p_idTramite: 0,
      p_idUsuario: 0,
      cargas: [],
      cargaSeleccionada: "",
      filtroEstado: 'todos',
      filtroRevisado: 'todos',
      // Formulario
      datoPlaObs: {},
      respuestas: [],
      dictation: new SpeechDictation(),
      isDictatingCampo: null,
      filtroLista: '',
      exportandoTodas: false,
    };
  },
computed: {
  planillasFiltradas() {
    const q = this.filtroLista.toLowerCase().trim();
    if (!q) return this.planillas;
    return this.planillas.filter(item =>
      String(item.numero ?? '').toLowerCase().includes(q) ||
      String(item.observacionEstandar ?? '').toLowerCase().includes(q) ||
      String(item.observacionComplementaria ?? '').toLowerCase().includes(q)
    );
  }
},
  mounted() {
    this.p_idTramite = this.$route.params.p_idtramite;
    this.p_idUsuario = window.sessionStorage.getItem("idUsuario");
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.cargarSemanasDelMes();
    this.fetchRespuestas();
    if (window.sessionStorage.getItem("cargaSeleccionada"))
      this.cargaSeleccionada = window.sessionStorage.getItem("cargaSeleccionada");
    if (window.sessionStorage.getItem("tipoObsSeleccionado"))
      this.tipoObsSeleccionado = window.sessionStorage.getItem("tipoObsSeleccionado");
    if (window.sessionStorage.getItem("filtroEstado"))
      this.filtroEstado = window.sessionStorage.getItem("filtroEstado");
    if (window.sessionStorage.getItem("filtroRevisado"))
      this.filtroRevisado = window.sessionStorage.getItem("filtroRevisado");
    this.getDataLista();
  },
  methods: {
    getFormattedDate(date) { return dateFormat.getFormattedDate(date); },

    // ── Lista ──────────────────────────────────────────────
async getDataLista() {
  if (!this.cargaSeleccionada || !this.tipoObsSeleccionado) return;
  this.itemSeleccionado = null;
  this.datoPlaObs = {};
  this.filtroLista = '';
  const endpoint = this.filtroEstado === 'pendientes'
    ? `/vwobservaciones/buscar-pendientes`
    : `/vwobservaciones/buscar-todos`;
  try {
    const response = await api.get(
      `${endpoint}?idTramite=${this.p_idTramite}&idCarga=${this.cargaSeleccionada}&tipo=${this.tipoObsSeleccionado}`
    );
    let data = response.data;
    if (this.filtroEstado === 'respondidos') {
      data = data.filter(item => item.idRespuesta);
    }
if (this.filtroRevisado === '1') {
  data = data.filter(item => item.revisado === 1);
} else if (this.filtroRevisado === '0') {
  data = data.filter(item => !item.revisado || item.revisado === 0);
}
    // Ordenamiento numérico por numero
    this.planillas = data.sort((a, b) => {
      const na = parseFloat(a.numero);
      const nb = parseFloat(b.numero);
      if (!isNaN(na) && !isNaN(nb)) return na - nb;
      return String(a.numero ?? '').localeCompare(String(b.numero ?? ''), 'es');
    });
  } catch (error) {
    console.error("Error al obtener planillas:", error);
  }
  window.sessionStorage.setItem("cargaSeleccionada", this.cargaSeleccionada);
  window.sessionStorage.setItem("tipoObsSeleccionado", this.tipoObsSeleccionado);
  window.sessionStorage.setItem("filtroEstado", this.filtroEstado);
  window.sessionStorage.setItem("filtroRevisado", this.filtroRevisado);
},
    seleccionarItem(item) {
      this.itemSeleccionado = item;
      this.datoPlaObs = {};
      const endpoint = item.nivel === "PLANILLA"
        ? "/vwplaobss/" + item.idRegistro
        : "/vwpladetobss/" + item.idRegistro;
      api.get(endpoint)
        .then(response => { this.datoPlaObs = response.data; })
        .catch(error => console.error("Error al obtener datos:", error));
    },

    cargarSemanasDelMes() {
      api.get(`/vwcargas/activas-por-tramite/${this.p_idTramite}`)
        .then(resp => { this.cargas = resp.data; });
    },

    // ── Formulario ─────────────────────────────────────────
    async guardarRespuesta() {
      if (!this.datoPlaObs.idRespuesta && !this.datoPlaObs.respuesta) {
        swal("Error!", "Ingrese una respuesta", "error");
        return;
      }
      if (!this.datoPlaObs.idRespuesta) {
        swal("Error!", "La respuesta estándar es obligatoria", "error");
        return;
      }
      try {
        this.datoPlaObs.idUsuarioRes = window.sessionStorage.getItem("idUsuario");
        const endpoint = this.itemSeleccionado.nivel === "PLANILLA" ? "/plaobss" : "/pladetobss";
        await api.post(endpoint, this.datoPlaObs);
        swal("Correcto!", "Respuesta registrada exitosamente!", "success");
        // Actualizar badge en lista sin recargar todo
        const idx = this.planillas.findIndex(
          p => p.idVwObservaciones === this.itemSeleccionado.idVwObservaciones
        );
        if (idx !== -1) {
          this.planillas[idx] = {
            ...this.planillas[idx],
            idRespuesta: this.datoPlaObs.idRespuesta || 1
          };
          this.planillas = [...this.planillas];
        }
      } catch {
        swal("Error!", "Intentelo de nuevo!", "error");
      }
    },

async fetchRespuestas() {
  try {
    const r = await api.get("/vwrespuestas");
    this.respuestas = r.data;
  } catch (e) { console.error("Error al obtener respuestas:", e); }
},

    startDictation(campo) {
      this.isDictatingCampo = campo;
      const valorActual = this.datoPlaObs[campo] || '';
      this.dictation.startDictation(transcript => {
        this.datoPlaObs[campo] = transcript;
      }, valorActual);
    },
    stopDictation() {
      this.isDictatingCampo = null;
      this.dictation.stopDictation();
    },

  decodificarTipoObs(tipo) {
    if (tipo === "D") return "Documental";
    if (tipo === "M") return "Médico";
    return tipo || "";
  },

  filasParaExcel(datos) {
    return datos.map((item) => ({
      "Tipo":                        this.decodificarTipoObs(item.tipo),
      "Nivel":                       item.nivel,
      "Número":                      item.numero,
      "Cédula":                      item.cedula,
      "Nombre":                      item.nombre,
      "Código":                      item.codigoElemento,
      "Nombre elemento":             item.nombreElemento,
      "Observación estándar":        item.observacionEstandar,
      "Observación complementaria":  item.observacionComplementaria,
      "Respuesta estándar":          item.respuestaEstandar,
      "Respuesta complementaria":    item.respuestaComplementaria,
    }));
  },

  descargarExcel(filas, nombreArchivo) {
    const hoja = XLSX.utils.json_to_sheet(filas);
    hoja["!cols"] = [
      { wch: 12 }, // Tipo
      { wch: 10 }, // Nivel
      { wch: 12 }, // Número
      { wch: 14 }, // Cédula
      { wch: 30 }, // Nombre
      { wch: 12 }, // Código
      { wch: 25 }, // Nombre elemento
      { wch: 35 }, // Observación estándar
      { wch: 35 }, // Observación complementaria
      { wch: 35 }, // Respuesta estándar
      { wch: 35 }, // Respuesta complementaria
    ];
    const libro = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(libro, hoja, "Observaciones");
    XLSX.writeFile(libro, nombreArchivo);
  },

  // Exporta exactamente lo que el usuario ve en la lista de la izquierda
  // (respeta período, tipo, estado, justificado y el buscador rápido)
  exportarVistaActual() {
    if (this.planillasFiltradas.length === 0) {
      swal("Aviso", "No hay registros para exportar", "info");
      return;
    }
    const filas = this.filasParaExcel(this.planillasFiltradas);
    const nombreArchivo = `observaciones_tramite_${this.p_idTramite}_${new Date()
      .toISOString()
      .slice(0, 10)}.xlsx`;
    this.descargarExcel(filas, nombreArchivo);
  },

  // Exporta TODAS las observaciones del trámite, sin importar los filtros de pantalla
  async exportarTodasObservaciones() {
    this.exportandoTodas = true;
    try {
      const response = await api.get(`/vwobservaciones/tramite/${this.p_idTramite}`);
      const datos = response.data || [];

      if (datos.length === 0) {
        swal("Aviso", "No se encontraron observaciones para este trámite", "info");
        return;
      }

      const filas = this.filasParaExcel(datos);
      const nombreArchivo = `observaciones_completas_tramite_${this.p_idTramite}_${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`;
      this.descargarExcel(filas, nombreArchivo);
    } catch (error) {
      console.error("Error al exportar observaciones:", error);
      swal("Error!", "No se pudo generar el reporte de observaciones", "error");
    } finally {
      this.exportandoTodas = false;
    }
  },	

  },
};
</script>

<style scoped>
.table-hover tbody tr {
  cursor: pointer;
}
</style>